/* tslint:disable */
/* eslint-disable */
export enum InvoiceStateId {
  PreCheck = 'PreCheck',
  WaitingForPrepaymentRegister = 'WaitingForPrepaymentRegister',
  NoPrepaymentRegister = 'NoPrepaymentRegister',
  WaitingForRepresentativeMandate = 'WaitingForRepresentativeMandate',
  NoMandate = 'NoMandate',
  WaitingInvoiceInformation = 'WaitingInvoiceInformation',
  WaitingForCreditDecision = 'WaitingForCreditDecision',
  WaitingForDisputeCheck = 'WaitingForDisputeCheck',
  Disputed = 'Disputed',
  CreditRatingNotOk = 'CreditRatingNotOk',
  Rejected = 'Rejected',
  WaitingForOfferToBeSent = 'WaitingForOfferToBeSent',
  WaitingForOfferApproval = 'WaitingForOfferApproval',
  OfferRejected = 'OfferRejected',
  WaitingForFinancing = 'WaitingForFinancing',
  Closed = 'Closed',
  WaitingForInvoiceToEndCustomer = 'WaitingForInvoiceToEndCustomer',
  MonitoringEndCustomerPayments = 'MonitoringEndCustomerPayments',
  WaitingFinalPayment = 'WaitingFinalPayment',
  WaitingForReport = 'WaitingForReport',
  Completed = 'Completed',
  WaitingForDisputeMailToBeSent = 'WaitingForDisputeMailToBeSent'
}
